<div class="h-full flex flex-col p-6 gap-4">
  <div class="flex flex-col w-full h-full  gap-4">
    <div class="flex flex-row justify-between items-center w-full h-auto">
      <span class="text-base font-semibold ">Productos agregados</span>
      <div class="w-auto  h-auto cursor-pointer toltip" title="Guardar como borrador" (click)="saveAsDraft()"
        [ngClass]="{'border-gray-200': cartItems.length === 0, 'border-outline': cartItems.length === 0 }">
        <i class="fi-rr-disk text-2xl items-center flex justify-center "
          [ngClass]="{'text-gray-200 cursor-not-allowed': cartItems.length === 0, 'text-primary-300 hover:text-primary-400': cartItems.length > 0}"></i>
      </div>
    </div>

    <div class="border-b-1 border-b-gray-300"></div>

    @if (cartItems && cartItems.length === 0) {
    <div class="flex flex-col w-full h-full gap-6">
      <div class="h-full w-full flex flex-col justify-center items-center">
        <div class="flex flex-row justify-center items-center  w-auto h-auto rounded-[36px] p-4 bg-orange-50">
          <div class="flex flex-row w-auto  h-auto">
            <i class="fi-rr-box-open text-4xl text-red-900"></i>
          </div>
        </div>

        <div class="text-center">
          <span class="font-semibold text-2xl">Sin productos por el momento</span>
        </div>

        <div class="text-center">
          <span class="text-sm">Agrega lo que necesitas para comenzar. Todo lo que elijas se mostrará aquí.</span>
        </div>
      </div>
    </div>
    } @else {
    <div class="flex flex-col w-full h-auto gap-6 overflow-auto">
      @for (item of cartItems; track item.id) {
      <div class="flex flex-row w-full h-auto gap-2 items-start">
        <img role="presentation" class="rounded-lg object-cover" [alt]="item.productImage"
          [src]="item.productImage || '/asset/imagen-no-disponible-1.jpg'" width="60" height="50" />
        <div class="flex flex-col w-full h-auto">
          <span class="text-sm">{{ item.name }}</span>
          <!-- Fila: ID -->
          <div class="flex flex-row w-full h-auto">
            <span class="text-[11px] text-gray-500">ID: {{ item.id }}</span>
          </div>
          @if (item.description) {
          <div class="flex flex-row w-full h-auto">
            <span class="text-[11px] text-gray-500">{{ item.description }}</span>
          </div>
          }
          <!-- Fila: Dimensiones + Espesor -->
          <div class="flex flex-row w-full h-auto gap-2">
            @if (item.dimensions && item.dimensions !== "NA") {
            <span class="text-xs text-text-secondary">{{ item.dimensions }} mm</span>
            }
            @if (item.thickness) {
            <span class="text-xs text-text-secondary">{{ item.thickness }} mm</span>
            }
          </div>
          <!-- Fila: Textura + Color -->
          <div class="flex flex-row w-full h-auto gap-2">
            @if (item.color?.name && item.color?.name !== "NA") {
            <span class="text-xs text-text-secondary">{{ item.color?.name }}</span>
            }
            @if (item.texture && item.texture !== "NA") {
            <span class="text-xs text-text-secondary">{{ item.texture }}</span>
            }
          </div>
          <!-- Fila: Caras -->
          <div class="flex flex-row w-full h-auto gap-2">
            @if (item.faceOne || item.faceTwo) {
            <span class="text-xs text-text-secondary">{{ getItemCoating(item) }}</span>
            }
          </div>
          <!-- Fila: Precio x Cantidad -->
          <div class="flex flex-row s-auto h-auto gap-1">
            <span class="text-xs text-text-secondary"> ${{ item.price | number:'1.2-2' }}</span>
            <span class="text-xs text-text-secondary"> x </span>
            <span class="text-xs text-text-secondary"> {{ item.quantity }} </span>
          </div>
        </div>

        <div class="flex flex-col justify-between w-auto h-full">
          <span class="font-semibold text-sm">${{ item.price * item.quantity | number:'1.2-2' }}</span>
          <div class="flex flex-row w-auto h-auto gap-3.5">
            <i class="flex justify-end items-end fi-rr-trash text-lg text-red-600 hover:text-red-800 cursor-pointer"
              (click)="removeItemFromTheCart(item.id, item.name)"></i>
            <i class="flex justify-end items-end fi-rr-edit text-lg text-primary-300 hover:text-primary-500 cursor-pointer"
              (click)="openProductDetailByCartItem(item)"></i>
          </div>
        </div>
      </div>
      }
    </div>
    }
  </div>

  <div class="border-b-1 border-b-gray-300"></div>

  <div class="flex flex-row justify-between w-full h-auto">
    <div class="flex flex-col w-full h-auto gap-1">
      <span class="font-semibold text-sm">Total</span>
      <span class="font-semibold text-2xl text-primary-300">${{ total | number:'1.2-2' }}</span>
    </div>
    <button [disabled]="!(cartItems && cartItems.length > 0)"
      class="flex flex-row flex-nowrap items-center shrink-0 w-auto h-auto rounded-3xl pt-4 pb-4 pr-6 pl-6 gap-3 bg-primary-300 hover:bg-primary-400 text-white font-semibold cursor-pointer disabled:bg-gray-200 disabled:cursor-not-allowed"
      (click)="proceed()">
      <span class="text-base whitespaces-nowrap">
        {{ isRelatedView ? 'Confirmar pedido' : 'Continuar' }}
      </span>
      <i class="fi-rr-arrow-small-right text-2xl flex justify-center items-center"></i>
    </button>
  </div>

</div>